/**
 * FORMS INITIAL STATES
 */

export const DEFAULT_IMAGE_LENGTH = 10000

/**
 * Media form
 */
export const initialFormMedia = {
    date_end: null,
    date_start: null,
    file: [],
    file_size: 0,
    height: 0,
    length: DEFAULT_IMAGE_LENGTH,
    md5: '',
    name: '',
    url: '',
    width: 0,
}

/**
 * Promo form
 */
 const initialFormPromo = {
    date_end: null,
    date_start: null,
    file: [],
    selected_media:'',
    file_size: 0,
    height: 0,
    length: DEFAULT_IMAGE_LENGTH,
    md5: '',
    name: '',
    url: '',
    width: 0,
}

/**
 * Layers form
 */
const initialFormLayers = {
    name: '',
    entry_point: 'index.html',
    url: '',
    file: [],
    file_size: 0,
    md5: '',
    length: 0,
    date_start: null,
    date_end: null,
}

/**
 * Playlists form
 */
const initialFormPlaylists = {
    name: '',
    slug: 'MAIN',
    priority: 0,
    date_start: null,
    date_end: null,
    chain_id: null,
}

/**
 * Edit playlists form
 */
const initialFormEditPlaylists = {
    name: '',
    slug: 'MAIN',
    priority: 0,
    date_start: null,
    date_end: null,
    chain_id: null,
}

/**
 * Channels form
 */
const initialFormChannels = {
    name: '',
    slug: '',
    status: 1,
    synced: 0,
    default_playlist_id: null,
    chain_id: null,
}

/**
 * Edit channels form
 */
const initialFormEditChannels = {
    name: '',
    slug: '',
    status: 1,
    synced: 0,
    default_playlist_id: null,
    chain_id: null,
}

/**
 * Map of form initial states
 */
const initialForm = {
    channels: initialFormChannels,
    media: initialFormMedia,
    layers: initialFormLayers,
    playlists: initialFormPlaylists,
    editPlaylists: initialFormEditPlaylists,
    editChannel: initialFormEditChannels,
    promo:initialFormPromo,
}

/* ****************************************** */

/**
 * Initial pagination
 */
const initialPagination = {
    currentPage: 0,
    perPage: 0,
    total: 0,
    from: 0,
    to: 0,
}

/**
 * isWorking
 */
const initialIsWorking = {
    channelDevices: false,
    channels: false,
    channelSingle: false,
    layers: false,
    media: false,
    mediaSingle: false,
    playlists: false,
}

/**
 * Reducer initial state
 */
const initialState = {
    /**
     * @type {import("../../types/Channel").Channel[]}
     */
    channels: [],
    /**
     * @type {import("../../types/Layer").Layer[]}
     */
    layers: [],
    /**
     * @type {import("../../types").Media[]}
     */
    media: [],
    /**
     * @type {import("../../types/Playlist").Playlist[]}
     */
    playlists: [],
    isWorking: {
        ...initialIsWorking,
    },
    contentPushContent: {
        channel: null,
        playlist: null,
    },
    counts: {
        pendingApprovalMedia: {
            count: false,
            isWorking: false,
        },
        pendingPushMedia: {
            count: false,
            isWorking: false,
        },
        pendingTestMedia: {
            count: false,
            isWorking: false,
        },
    },
    form: {
        ...initialForm,
    },
    pagination: {
        channels: { ...initialPagination },
        layers: { ...initialPagination },
        media: { ...initialPagination },
        playlists: { ...initialPagination },
    },
    selected: {
        /**
         * @type {import("../../types/Channel").Channel | null}
         */
        channels: null,
        /**
         * @type {import("../../types/Layer").Layer | null}
         */
        layers: null,
        /**
         * @type {import("../../types").Media | null}
         */
        media: null,
        /**
         * @type {import("../../types/Playlist").Playlist | null}
         */
        playlists: null,
    },
    uploaded: null,
}

export default initialState

export { initialForm, initialIsWorking, initialPagination }
